/**
 * RESPONSIBILITY: draw an event's tags, quietly, wherever the event is drawn.
 *
 * They used to sit in the line above the title, in the same wide gold capitals as the
 * date — "SAT, 26 SEPT 2026 · WORSHIP · SEASONAL" — which gave the shelf an event is
 * filed on the same weight as the event. The date earns that line: it is why somebody is
 * reading the card. A tag is looked up rather than read, so it goes last and stays faint.
 *
 * An event may drop them altogether. Several are tagged only so a band elsewhere can
 * find them, and naming that tag on the card tells a visitor nothing. Only an explicit
 * no counts: a row saved before the switch existed holds no answer, and the answer to a
 * question nobody was asked is yes.
 */
import type { EventRow } from '@app/sections';

export function EventTags({ e }: { e: EventRow }) {
  const tags = e.showTags === false ? [] : e.categories ?? [];
  if (tags.length === 0) return null;

  return (
    <p className="evtags">
      {tags.map((k) => <span className="evtag" key={k}>{k}</span>)}
    </p>
  );
}
